export default "__VITE_ASSET__cwPt$Zf9__"